import Box from '@mui/material/Box';
import { ReactNode } from 'react';

const SKILLS_CONTENT_MAX_WIDTH_IN_PX = 960;

export default function TreadAgentSkillsColumn({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ flexGrow: 1, overflowY: 'auto', pb: 3, pt: 8, px: 3 }}>
      <Box sx={{ maxWidth: `${SKILLS_CONTENT_MAX_WIDTH_IN_PX}px`, mx: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
}
